import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Calendar } from 'primereact/calendar';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const DemandlistvwListPage = (props) => {
		const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		},
		branchcode: {
			tagTitle: $t('branch'),
			value: '',
			valueType: 'single',
			options: [],
		},
		groupid: {
			tagTitle: $t('group'),
			value: '',
			valueType: 'single',
			options: [],
		},
		empcode: {
			tagTitle: $t('employee'),
			value: '',
			valueType: 'single',
			options: [],
		},
		paydate: {
			tagTitle: $t('paydate'),
			value: [],
			valueType: 'range-date',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, apiUrl, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	// return sum of payment for the current records
	const totalPayment = utils.sum(records, 'payment');
	function DisbursementdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.disbursementdate )}</>
			);
		}
	}
	function PaydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.paydate )}</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-demandlistvw`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="DemandlistvwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('demandList')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-2 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
                <div className="col-12 md:col-2 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('branchcode', options)}  apiPath="components_data/branchcode_option_list_2"  >
                            {
                            ({ response }) => 
                            <>
                            <Title title={$t('filterByBranch')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'branchcode', e.value)} value={filters.branchcode.value} optionLabel="label" optionValue="value" options={filters.branchcode.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-2 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('groupid', options)}  apiPath="components_data/groupid_option_list_3"  >
                            {
                            ({ response }) => 
                            <>
                            <Title title={$t('filterByGroup')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'groupid', e.value)} value={filters.groupid.value} optionLabel="label" optionValue="value" options={filters.groupid.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-2 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('empcode', options)}  apiPath="components_data/empcode_sale_option_list"  >
                            {
                            ({ response }) => 
                            <>
                            <Title title={$t('filterByEmployee')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'empcode', e.value)} value={filters.empcode.value} optionLabel="label" optionValue="value" options={filters.empcode.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-2 comp-grid" >
                    <div className="p-3 mb-3">
                        <Title title={$t('filterByPaydate')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                        <div className="">
                            <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.paydate.value} onChange={(e) => setFilterValue('paydate', e.value)} placeholder={$t('selectDate')}   />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                value={records} 
                                dataKey="amortid" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="stack" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column  field="amortid" header={$t('amortid')}  sortable={true} ></Column>
                                <Column  field="branchname" header={$t('branchname')}  sortable={true} ></Column>
                                <Column  field="groupname" header={$t('groupname')}  sortable={true} ></Column>
                                <Column  field="loanaccountno" header={$t('loanaccountno')}  sortable={true} ></Column>
                                <Column  field="membername" header={$t('membername')}  sortable={true} ></Column>
                                <Column  field="disbursementdate" header={$t('disbursementdate')} body={DisbursementdateTemplate} sortable={true} ></Column>
                                <Column  field="loanamount" header={$t('loanamount')}  sortable={true} ></Column>
                                <Column  field="statename" header={$t('statename')}  sortable={true} ></Column>
                                <Column  field="paidemi" header={$t('paidemi')}  sortable={true} ></Column>
                                <Column  field="balance" header={$t('balance')}  sortable={true} ></Column>
                                <Column  field="tot_emi_due" header={$t('totEmiDue')}  sortable={true} ></Column>
                                <Column  field="total_paid" header={$t('totalPaid')}  sortable={true} ></Column>
                                <Column  field="emi1" header={$t('emi1')}  sortable={true} ></Column>
                                <Column  field="emi2" header={$t('emi2')}  sortable={true} ></Column>
                                <Column  field="empname" header={$t('empname')}  sortable={true} ></Column>
                                <Column  field="empcode" header={$t('empcode')}  sortable={true} ></Column>
                                <Column  field="paydate" header={$t('paydate')} body={PaydateTemplate} sortable={true} ></Column>
                                <Column  field="addressline1" header={$t('addressline1')}  sortable={true} ></Column>
                                <Column  field="mobileno" header={$t('mobileno')}  sortable={true} ></Column>
                                <Column  field="period" header={$t('period')}  sortable={true} ></Column>
                                <Column  field="payment" header={$t('payment')}  sortable={true} ></Column>
                                <Column  field="paid" header={$t('paid')}  sortable={true} ></Column>
                                <Column  field="meeting_center_name" header={$t('meetingCenterName')}  sortable={true} ></Column>
                                <Column  field="loanpaymentfrequency" header={$t('frequency')}  sortable={true} ></Column>
                                <Column  field="overdue" header={$t('overdue')}  sortable={true} ></Column>
                                <Column  field="ledger_balance" header={$t('balance')}  sortable={true} ></Column>
                                <Column  field="totalpay" header={$t('totalpay')}  sortable={true} ></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                            <div className="flex justify-content-around font-bold p-3">
                                <div>Total Payment : <Chip label={totalPayment} /></div>
                            </div>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
DemandlistvwListPage.defaultProps = {
	primaryKey: '',
	pageName: 'demandlistvw',
	apiPath: 'demandlistvw/index',
	routeName: 'demandlistvwlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default DemandlistvwListPage;
